import React from 'react';

// Full-width green header bar with black bold centered title (mockup screens 2-12).
export function HeaderBar({ title }) {
  return (
    <div className="flex h-[90px] w-full items-center justify-center bg-primary-500 px-4">
      <h1 className="text-center text-2xl font-bold text-black">{title}</h1>
    </div>
  );
}
